import React from 'react';
import { Box, Typography } from '@mui/material';

import GameTagCard from './tagCard';

const TeamTags = [
    'Game Highlight',
    'Clean Game',
    'All Offensive Possessions',
    'All Defensive Possessions',
    'Build Up Opponent Half',
    'Build Up Own Half',
    'Build Up Goalkeeper',
    'Started From Goalkeeper',
    'Counter-Attacks',
    'Started From Interception',
    'Started From Tackle',
    'Started From Throw In'
];

const ActionTags = [
    'Goals',
    'Chances',
    'Free Kicks',
    'Corners',
    'Crosses',
    'Draw Fouls',
    'Turnovers',
    'Offsides',
    'Penalties Gained',
    'Saved',
    'Blocked',
    'Clearance'
];

const GameTagButtonList = ({ selectedTag, onShow, isTeams, t, isOur, onChangeTeam, loadingTag }) => {
    const teamTagsToShow = isTeams ? TeamTags.slice(2) : TeamTags;

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '10px 20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}
        >
            {/* Team Tabs */}
            {onChangeTeam && (
                <Box sx={{ display: 'flex', gap: '4px', marginBottom: '16px' }}>
                    <Box
                        onClick={() => onChangeTeam(true)}
                        sx={{
                            padding: '6px 16px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            backgroundColor: isOur ? '#6366f1' : '#f3f4f6',
                            transition: 'all 0.15s ease',
                            '&:hover': {
                                backgroundColor: isOur ? '#6366f1' : '#e5e7eb'
                            }
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: isOur ? '#ffffff' : '#6b7280'
                            }}
                        >
                            {t('Our Team')}
                        </Typography>
                    </Box>
                    <Box
                        onClick={() => onChangeTeam(false)}
                        sx={{
                            padding: '6px 16px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            backgroundColor: !isOur ? '#6366f1' : '#f3f4f6',
                            transition: 'all 0.15s ease',
                            '&:hover': {
                                backgroundColor: !isOur ? '#6366f1' : '#e5e7eb'
                            }
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '12px',
                                fontWeight: 600,
                                color: !isOur ? '#ffffff' : '#6b7280'
                            }}
                        >
                            {t('Opponent')}
                        </Typography>
                    </Box>
                </Box>
            )}

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {/* Team Analysis Section */}
                <Box>
                    <Typography
                        sx={{
                            fontSize: '11px',
                            fontWeight: 600,
                            color: '#9ca3af',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            marginBottom: '10px',
                            paddingLeft: '2px'
                        }}
                    >
                        {t('Team Analysis')}
                    </Typography>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(6, 1fr)',
                            gap: '8px'
                        }}
                    >
                        {teamTagsToShow.map((tag, index) => (
                            <GameTagCard
                                t={t}
                                key={index}
                                isSelected={selectedTag === tag}
                                tagname={tag}
                                onShow={onShow}
                                isLoading={loadingTag === tag}
                            />
                        ))}
                    </Box>
                </Box>

                {/* Individual Actions Section */}
                <Box>
                    <Typography
                        sx={{
                            fontSize: '11px',
                            fontWeight: 600,
                            color: '#9ca3af',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            marginBottom: '10px',
                            paddingLeft: '2px'
                        }}
                    >
                        {t('Individual Actions')}
                    </Typography>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(6, 1fr)',
                            gap: '8px'
                        }}
                    >
                        {ActionTags.map((tag, index) => (
                            <GameTagCard
                                t={t}
                                key={index}
                                isSelected={selectedTag === tag}
                                tagname={tag}
                                onShow={onShow}
                                isLoading={loadingTag === tag}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default GameTagButtonList;
